module.exports = __webpack_public_path__ + "prod/1.42.2/img/pain-2.b4be76d7.svg";